import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./style.css";

export default function YogaPostCard({ post, onUpdate, onDelete }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [likes, setLikes] = useState(post.likes.length);
  const [liked, setLiked] = useState(post.likes.includes(user?._id));
  const [saved, setSaved] = useState(post.saves.includes(user?._id));
  const [showDetails, setShowDetails] = useState(false);
  const [comments, setComments] = useState(post.comments || []);
  const [newComment, setNewComment] = useState("");

  const token = user?.token || localStorage.getItem("token");

  const handleLike = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/yoga/post/${post._id}/like`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setLiked(response.data.action === "liked");
      setLikes(response.data.likesCount);
    } catch (error) {
      console.error("Erro ao curtir:", error);
    }
  };

  const handleSave = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/yoga/post/${post._id}/save`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSaved(!saved);
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  };

  const handleComment = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/yoga/post/${post._id}/comment`,
        { text: newComment },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setComments(response.data.data);
      setNewComment("");
    } catch (error) {
      console.error("Erro ao comentar:", error);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Tem certeza que deseja deletar este post?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACKEND_URL}/api/yoga/post/${post._id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        onDelete(post._id);
      } catch (error) {
        console.error("Erro ao deletar:", error);
      }
    }
  };

  return (
    <div className="yoga-post-card">
      {/* Cabeçalho do Post */}
      <div className="yoga-post-header">
        <div className="yoga-post-author">
          <img 
            src={post.author.profilePicture || post.author.avatar} 
            alt={post.author.name}
            className="yoga-author-avatar"
          />
          <div className="yoga-author-info">
            <h4>{post.author.name}</h4>
            <p>{new Date(post.createdAt).toLocaleDateString('pt-BR')}</p>
          </div>
        </div>
        <div className="yoga-post-actions">
          {post.author._id === user?._id && (
            <button className="btn-delete-yoga" onClick={handleDelete}>
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Imagem/Thumbnail */}
      {post.images && post.images.length > 0 && (
        <div className="yoga-post-image">
          <img 
            src={post.images[0].url} 
            alt={post.title}
            onClick={() => setShowDetails(true)}
            style={{ cursor: "pointer" }}
          />
          {post.duration && (
            <span className="yoga-duration-badge">{post.duration} min</span>
          )}
        </div>
      )}

      {/* Informações do Post */}
      <div className="yoga-post-content">
        <h3>{post.title}</h3>
        
        <div className="yoga-post-meta">
          <span className="yoga-badge yoga-type">{post.postType}</span>
          <span className="yoga-badge yoga-level">{post.level}</span>
          {post.yogaStyle && (
            <span className="yoga-badge yoga-style">{post.yogaStyle}</span>
          )}
        </div>

        <p className="yoga-description">
          {post.description.substring(0, 150)}
          {post.description.length > 150 ? "..." : ""}
        </p>

        <div className="yoga-post-stats">
          <span>{likes} curtidas</span>
          <span>{comments.length} comentários</span>
          <span>{post.views} visualizações</span>
        </div>
      </div>

      {/* Ações */}
      <div className="yoga-post-footer">
        <button 
          className={`yoga-action-btn ${liked ? "active" : ""}`}
          onClick={handleLike}
        >
          ❤️ Curtir
        </button>
        <button 
          className="yoga-action-btn"
          onClick={() => setShowDetails(true)}
        >
          💬 Comentar
        </button>
        <button 
          className={`yoga-action-btn ${saved ? "active" : ""}`}
          onClick={handleSave}
        >
          🔖 Salvar
        </button>
        <button 
          className="yoga-action-btn"
          onClick={() => {
            navigator.clipboard.writeText(window.location.href);
            alert("Link copiado!");
          }}
        >
          📤 Compartilhar
        </button>
      </div>

      {/* Modal de Detalhes */}
      {showDetails && (
        <div className="yoga-modal-overlay" onClick={() => setShowDetails(false)}>
          <div className="yoga-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="yoga-modal-close"
              onClick={() => setShowDetails(false)}
            >
              ✕
            </button>

            <div className="yoga-modal-body">
              {post.videos && post.videos.length > 0 ? (
                <video 
                  src={post.videos[0].url} 
                  controls
                  className="yoga-modal-video"
                />
              ) : post.images && post.images.length > 0 ? (
                <img 
                  src={post.images[0].url} 
                  alt={post.title}
                  className="yoga-modal-image"
                />
              ) : null}

              <div className="yoga-modal-info">
                <h2>{post.title}</h2>
                <p>{post.description}</p>

                {post.asanas && post.asanas.length > 0 && (
                  <div className="yoga-asanas-list">
                    <h4>Posturas (Asanas):</h4>
                    <ul>
                      {post.asanas.map((asana, idx) => (
                        <li key={idx}>
                          <strong>{asana.name}</strong> ({asana.sanskritName})
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {post.benefits && post.benefits.length > 0 && (
                  <div className="yoga-benefits-list">
                    <h4>Benefícios:</h4>
                    <ul>
                      {post.benefits.map((benefit, idx) => (
                        <li key={idx}>{benefit}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {post.equipment && post.equipment.length > 0 && (
                  <div className="yoga-equipment">
                    <h4>Equipamentos:</h4>
                    <div className="equipment-list">
                      {post.equipment.map((item, idx) => (
                        <span key={idx} className="equipment-tag">{item}</span>
                      ))}
                    </div>
                  </div>
                )}

                <div className="yoga-rating-section">
                  <h4>Avaliação: {post.averageRating?.toFixed(1) || "N/A"}/5</h4>
                  <div className="rating-input">
                    <select defaultValue="0" onChange={(e) => {
                      if (e.target.value > 0) {
                        // Implementar avaliação
                      }
                    }}>
                      <option value="0">Avalie este post</option>
                      <option value="1">⭐ 1 - Não gostei</option>
                      <option value="2">⭐⭐ 2 - Poderia melhorar</option>
                      <option value="3">⭐⭐⭐ 3 - Bom</option>
                      <option value="4">⭐⭐⭐⭐ 4 - Muito bom</option>
                      <option value="5">⭐⭐⭐⭐⭐ 5 - Excelente</option>
                    </select>
                  </div>
                </div>

                <div className="yoga-comments-section">
                  <h4>Comentários ({comments.length})</h4>
                  <div className="yoga-comments-list">
                    {comments.slice(0, 5).map((comment) => (
                      <div key={comment._id} className="yoga-comment">
                        <img 
                          src={comment.user?.avatar || comment.user?.profilePicture}
                          alt={comment.user?.name}
                          className="comment-avatar"
                        />
                        <div className="comment-content">
                          <strong>{comment.user?.name}</strong>
                          <p>{comment.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <form onSubmit={handleComment} className="yoga-comment-form">
                    <input 
                      type="text"
                      placeholder="Deixe um comentário..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      className="yoga-comment-input"
                    />
                    <button type="submit" className="yoga-comment-btn">
                      Enviar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
